export default __webpack_public_path__ + "static/media/2.979e5133.png";